export default __webpack_public_path__ + "static/media/googlemeet.24979101.png";